import { mapTagTypeToLookupOption } from 'app/components/Candidate/CandidateProfile/CandidateHeader/TagsWrapper/tagTypeHelpers';
import { ITagType } from 'app/models/Candidate/Tags';
import { candidateSearchFilterName } from './SearchUtils';

/** Candidate global search only — all active tag types from GET /candidate/tags/types/active */
export const getCandidateSearchTagTypesFilterOpts = (tagTypes: ITagType[] = []) =>
  tagTypes.map(tagType => {
      const option = mapTagTypeToLookupOption(tagType);
      return {
        id: option.id,
        name: option.name,
        value: option.value,
        fullDescription: tagType.fullDescription,
      };
    });

export const withCandidateSearchApiTagsFieldConfig = (fields: any[]) =>
  fields.map(field =>
    field.name === candidateSearchFilterName.candidateTags
      ? {
          ...field,
          getOptionTooltip: (option: { fullDescription?: string }) => option.fullDescription?.trim() || null,
        }
      : field,
  );
